export const DEMOTION_GUARD_FLAG = 'CONTACT_DEMOTION_PLAN_GUARD'

export const RESTORE_SKIP_TEXT = {
  'no-plan-recorded': 'billing was not running when the status was changed',
  'already-billing': 'a payment plan is already active',
  'plan-missing': 'the plan that was billing no longer exists',
  'plan-not-inactive': 'the plan that was billing has been canceled or switched on since',
  'plans-changed': "the client's payment plans were changed after the status change",
  'restore-failed': 'the restore could not be completed',
}
